
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.365 9.74L22 7.962h-3.625A11.254 11.254 0 0011.998 6c-2.367 0-4.552.724-6.364 1.962H2L3.635 9.74a4.996 4.996 0 106.763 7.357l1.6 1.744 1.602-1.742a4.999 4.999 0 106.766-7.359zM7.002 16.814a3.38 3.38 0 110-6.761 3.38 3.38 0 010 6.761zM12 13.334c0-2.224-1.618-4.134-3.754-4.95a9.702 9.702 0 013.752-.75 9.71 9.71 0 013.754.75C13.618 9.2 12 11.11 12 13.334zm4.996 3.48a3.38 3.38 0 110-6.761 3.38 3.38 0 010 6.761zm0-5.155a1.772 1.772 0 100 3.544 1.772 1.772 0 000-3.544zm-8.221 1.774a1.772 1.772 0 11-3.544.001 1.772 1.772 0 013.544 0z"}})])
          )
        }
      }
    